import React, { useState, useEffect } from "react";
import styles from "./Navbar.module.css";
import "../i18n";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.navScrolled : ""}`}>
      <div className={styles.inner}>
        <div className={styles.logo}>{t('app.brand')}</div>
        <div className={styles.links}>
          <a href="#catalog" className={styles.link}>{t('app.catalog')}</a>
          <a href="#steps" className={styles.link}>{t('app.how_it_works')}</a>
          <a href="#pricing" className={styles.link}>{t('app.pricing')}</a>
        </div>
        <LanguageSwitcher />
      </div>
    </nav>
  );
};

export default Navbar;
